import 
    React
    , {
          useState
        , useEffect
        , useLayoutEffect
        , useRef
    } from 'react';

import SearchSection from './SearchSection';

const Search = () => {
    console.debug('Search()');

    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    useEffect(() => {

        const handleResize = () => {
            console.debug('Search: handleResize()');
            setWindowHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, []);
    
    return (

        <main
            //className = { styles.searchPage } // Removed SASS styling/naming,
            className = 'search'                // replaced with global "search" CSS identifier
            //style = {{
                //outline: "blue 3px solid" // Temporary for hard debugging
            //}}
            >

            <SearchSection
                showMap = { true }
                windowHeight = { windowHeight }
                />

        </main>
    );
};

export default Search;
